// extracted by css-extract-rspack-plugin
export default {"choiceList":"choiceList-lhT94t","choice":"choice-enONYm"};